import recordMark, { MARK_TIME_KEY } from '../recordMark';
import recordCustomTiming from '../recordCustomTiming';
import getResourcesLoadTime from '../getResourcesLoadTime';
import { Tags, Resource } from '../types';

export type RecordPageReadyOptions = {
  /**
   * Collection of resource full/partial names & name regex patterns
   */
  resources?: Resource[];
  tags?: Tags;
};

/**
 * Records a custom mark that the page is now ready for the user based
 * on the UI that has been rendered and optional resources to be loaded
 *
 * @returns A promise containing the page ready for user time
 */
const recordPageReady = ({
  resources = [],
  tags = {},
}: RecordPageReadyOptions = {}): Promise<number | undefined> => {
  const uiReadyTime = window.performance.now();

  return getResourcesLoadTime(resources).then(resourcesLoadTime => {
    const pageReadyForUserTime = Math.max(uiReadyTime, resourcesLoadTime || 0);

    // Record an action to attach additional metadata and support dashboards
    // that were created before `recordCustomTiming` was available.
    recordMark('page_ready_for_user', {
      ...tags,
      [MARK_TIME_KEY]: pageReadyForUserTime,
    });

    // Record a custom timing to be able to get this metric on views.
    recordCustomTiming('page_ready_for_user', pageReadyForUserTime);

    return pageReadyForUserTime;
  });
};

export default recordPageReady;
